class APIConfig {
  constructor() {}
  static baseUrl = process.env.REACT_APP_PG_CONTROLLER;
}

export default APIConfig;
